import { default as Vuex, Module } from "vuex";

class LocationsettingsState {
  rmisEnabled: boolean = false
  requireProcessingStationForIntakeBatches: boolean = false
}

class LocationSettings implements Module<LocationsettingsState, any> {
  namespaced = true;
  state: LocationsettingsState = new LocationsettingsState();
  mutations = {
    clear(state: LocationsettingsState) {
      state.rmisEnabled = false;
      state.requireProcessingStationForIntakeBatches = false;
    },
    set(state: LocationsettingsState, payload: { rmisEnabled: boolean, requireProcessingStationForIntakeBatches: boolean }) {
      state.rmisEnabled = payload.rmisEnabled
      state.requireProcessingStationForIntakeBatches = payload.requireProcessingStationForIntakeBatches
    }
  };
}

const locationSettingModule: LocationSettings = new LocationSettings();

export default locationSettingModule;
